import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {
  fetchGiftCardSummary,
  searchGiftCard,
} from '../actions';
import { getShop } from '../../../auth/selectors';
import GiftCardsLookup from '../components/GiftCardsLookup';

const GiftCardsLookupContainer = compose(
  connect(
    state => ({
      shopId: getShop(state),
    }),
    { fetchGiftCardSummary },
  ),
  withState('value', 'setValue', ''),
  withHandlers({
    onChange: props => e => props.setValue(e.target.value),
    search: props => (e) => {
      e.preventDefault();
      return searchGiftCard(props.shopId, props.value).then((giftCard) => {
        props.setGiftCard(giftCard);
      });
    },
  })
)(GiftCardsLookup);

export default GiftCardsLookupContainer;
